import React, { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import foundations from 'theme/foundations';

type Props = {
  image: string;
  overlay?: boolean;
};

const BackgroundImage: React.FC<Props> = ({
  image,
  overlay = false,
}: Props) => {
  return (
    <Box
      zIndex="-1"
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      sx={{
        background: foundations.colors.blue[900],
        // @ts-ignore
        // eslint-disable-next-line
        background: overlay
          ? `
          linear-gradient(
            ${foundations.colors.blueAlpha[900]},
            ${foundations.colors.blueAlpha[900]}
          ),
          url(${image})
        `
          : `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }}
    />
  );
};

export default BackgroundImage;
